<script>
import BaseField from '@/components/BaseField.vue';
import form from '@/utils/form';

export default {
  name: 'NameForm',
  components: { BaseField },
  props: {
    value: String,
    field: String,
    error: String,
  },
  data() {
    return {
      name: form.createFieldObject('string', this.field, this.value, { required: this.error }),
    };
  },
  mounted() {
    this.$refs.field.focus();
  },
  methods: {
    async submit() {
      form.validateField(this, 'name');

      if (this.name.error) return;

      this.$emit('submit', this.name.value);
    },
    abort() {
      this.$emit('abort');
    },
  },
};
</script>

<template lang="pug">
form.name-form(@submit.prevent="submit")
  BaseField.field(v-model="name.value" v-bind="name" ref="field")
  Btn.btn(green lg @click="submit") Сохранить
  Btn.btn(grey lg @click="abort") Отменить
</template>

<style scoped lang="scss">
.name-form {
  display: flex;
  gap: 20px;
}

.field {
  flex-grow: 1;
}

@media (max-width: 768px) {
  .name-form {
    flex-wrap: wrap;
  }

  .field {
    width: 100%;
  }

  .btn {
    flex-grow: 1;
  }
}
</style>
